import Cookies from 'cookies-js';

import BookingButton from '../components/BookingButton';

const STORAGE_PREFIX = '5thavenue-';
const KEY_SERVICES = 'services'; // eslint-disable-line no-unused-vars
const KEY_CONTACT_INFO = 'contact-info'; // eslint-disable-line no-unused-vars
const KEY_UNIQUE_USER_ID = 'user-uuid';

function checkIsLocalStorageAvailable() {
    const key = 'isAvailable';
    try {
        localStorage.setItem(key, true);
        return localStorage.getItem(key);
    } catch (err) {
        return false;
    }
}

const CookieStorage = {
    STORAGE_PREFIX: STORAGE_PREFIX,
    KEY_SERVICES: KEY_SERVICES,
    KEY_UNIQUE_USER_ID: KEY_UNIQUE_USER_ID,

    getItem: function(key) {
        try {

            return JSON.parse(Cookies.get(STORAGE_PREFIX + key));
        } catch (err) {
            return null;
        }
    },

    setItem: function(key, value) {
        Cookies.set(STORAGE_PREFIX + key, JSON.stringify(value));
        BookingButton.updateCount();
        return value;
    },
};

const LocalStorage = { 
    STORAGE_PREFIX: STORAGE_PREFIX,
    KEY_SERVICES: KEY_SERVICES,
    KEY_UNIQUE_USER_ID: KEY_UNIQUE_USER_ID,
    
    getItem: function(key) {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_PREFIX + key));
        } catch (err) {
            return null;
        }
    },

    setItem: function(key, value) {
        localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
        BookingButton.updateCount();
        return value;
    },
};

const Storage = {
    STORAGE_PREFIX: STORAGE_PREFIX,
    KEY_SERVICES: KEY_SERVICES,
    KEY_UNIQUE_USER_ID: KEY_UNIQUE_USER_ID,

    getItem: function(key) {
        if (checkIsLocalStorageAvailable()) {
            return LocalStorage.getItem(key);
        } else {
            return CookieStorage.getItem(key);
        }
    },

    setItem: function(key, value) {
        if (checkIsLocalStorageAvailable()) {
            LocalStorage.setItem(key, value);
        } else {
            CookieStorage.setItem(key, value);
        }
    },
}

export default Storage;



// WEBPACK FOOTER //
// ./scripts/util/Storage.js